module.exports = __webpack_public_path__ + "static/media/festival_01.78e6aa9c.jpg";